import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { isMobile } from "react-device-detect";
import '../global.css';
import logoImage from '../../images/logo.png';
import ParentLoginWrapper from './styles/parentlogin.style'
import { DatePicker, notification, Tabs } from 'antd';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';
import * as PatientActions from '../../actions/patient';
import * as DeviceDetails from '../../utils/deviceDetails';
import ParentWaiting from '../parentWaiting/parentWaiting';
import MobileParentWaiting from '../parentWaiting/mobile/mobileparentWaiting';
import settings from '../../reducers/setting';
import Loader from '../../components/Loader/loader';
import JoinModal from '../../components/joinModal/joinModal';

const dateFormat = 'MM/DD/YYYY';
const { TabPane } = Tabs;

class ParentLogin extends Component {
	constructor(props) {
      super(props);
      this.state = {
         patientLastName: "",
         patientDob: "",
         therapistRoom: "",
         mobileNumber: "", 
         guestName: "", 
         guestMobileNumber: "",         
         disableButton: true,
         warningVisible: true,
         differentRoomModal: false,
         showLoader: true,
         selectedType: 'kureUser'
      }
      this.handleInputChange = this.handleInputChange.bind(this);
      this.createActiveCall = this.createActiveCall.bind(this);
   }

   
   componentDidMount(){
      window.sessionStorage.setItem('patientConnecting', "no");
      // window.localStorage.removeItem('user')
		const { dispatch, match } = this.props;
      const { params } = match;
		const deviceBrowser = DeviceDetails.getBrowser();
		if(deviceBrowser && ["chrome", "safari"].indexOf(deviceBrowser.toLowerCase()) !== -1){
			this.setState({
				warningVisible: false
			})
      }
      if(window.localStorage.getItem("patientCallId")){
         const callId = window.localStorage.getItem("patientCallId");
         dispatch(PatientActions.getActiveCallDetails({callId}, (activeCall) => {
            if(params.therapistRoom !== activeCall.therapistRoom){
               this.setState({
                  differentRoomModal: true,
                  showLoader: false
               });
            }else{
               this.setState({
                  showLoader: false
               });
            }
         }));
      }else{
         setTimeout(() => {
            this.setState({
               showLoader: false
             })
         }, 3000);
        
      }

   }
   
   componentDidUpdate(prevProps){
      if(this.props.setting.currentUser && !prevProps.setting.currentUser && !window.localStorage.getItem("patientCallId")){
         const self = this;
         this.setState({
            mobileNumber: this.props.setting.currentUser.mobileNumber
         }, () => {
            self.createActiveCall();
         })
      }
   }

   
   handleInputChange(obj){
      let { state } = this;
      state = Object.assign({}, state, obj);
      if(state.mobileNumber !== "" && state.mobileNumber.length > 7){
         state = Object.assign({}, state, {disableButton : false});
      }else if(state.patientDob !== "" && state.patientLastName && state.patientLastName.trim() !== ""){
         state = Object.assign({}, state, {disableButton : false});
      }else if(state.guestName && state.guestName.trim() !== ""){
         state = Object.assign({}, state, {disableButton : false});
      }else{
         state = Object.assign({}, state, {disableButton : true});
      }

      this.setState(state);
   }

   closeWarning = () => {
      this.setState({
         warningVisible: false,
      });  
   }

   createActiveCall(){
      const { match , dispatch, setting} = this.props;
      const { params } = match; 
      const { selectedType, patientLastName, patientDob, mobileNumber, guestName, guestMobileNumber } = this.state;

      const patientDeviceInfo = {
         OS: DeviceDetails.getOS(),
         browser : DeviceDetails.getBrowser(),
         device: isMobile ? "Mobile/Tablet" : "Desktop"
      }
         
      let data = {}
      
      if(selectedType === "kureUser" && mobileNumber && mobileNumber.length > 7){
         data = {
            mobileNumber : mobileNumber
         };
      } else if(selectedType === "guest" && guestName){
         const mobileNumberRand = (guestMobileNumber) ? guestMobileNumber : '9112345'+ (Math.floor(Math.random()*90000) + 10000);
         this.handleInputChange({guestMobileNumber : mobileNumberRand})
         data = {
            guestName, 
            guestMobileNumber: mobileNumberRand
         }
      } else {
         const mobileNumberRand = (guestMobileNumber) ? guestMobileNumber : '9112345'+ (Math.floor(Math.random()*90000) + 10000);
         this.handleInputChange({guestMobileNumber : mobileNumberRand})
         data = {
            patientLastName, 
            patientDob,
            guestMobileNumber: mobileNumberRand
         }
      }

      dispatch(PatientActions.postActiveCall({ ...data, patientDeviceInfo,therapistRoom: params.therapistRoom}, null, () => {

        
         setTimeout(() => {
            if(setting && setting.currentUser && setting.currentUser.therapistRoom){
               window.location.href = ("/videoRoom/" + setting.currentUser.therapistRoom);
            } else {
                window.history.back()
            }
           
         }, 1000);
         notification['error']({
            message: 'Error',
            description: 'Could not connect. Please check the information provided.',
            duration: 30
         });
      }));
   }

   handleTabClick = (type) => {
      type = (type) ? type : this.state.selectedType;
      this.setState({
         patientLastName: "",
         patientDob: "", 
         mobileNumber: "", 
         guestName: "", 
         guestMobileNumber: "",
         selectedType: type,
         disableButton: true
      });
   }

	render() {
      let { differentRoomModal, showLoader } = this.state;

      if(showLoader){
         return <Loader />;
      }
      const { match, setting, patient } = this.props;
      const { params } = match; 
      const { patientLastName, patientDob, disableButton, guestMobileNumber, guestName,selectedType, mobileNumber } = this.state;
      let newguestMobileNumber;

      if(selectedType === "kureUser" && mobileNumber && mobileNumber.length > 7){
         if(mobileNumber && mobileNumber!=""){
            window.localStorage.setItem('user', mobileNumber)
         }
      } else if(selectedType === "guest" && guestName){
         if(guestMobileNumber && guestMobileNumber!=""){
            window.localStorage.setItem('user', guestMobileNumber)
   
            newguestMobileNumber = guestMobileNumber
         }
      } else {
         if(guestMobileNumber && guestMobileNumber!=""){
            window.localStorage.setItem('user', guestMobileNumber)
            newguestMobileNumber = guestMobileNumber
         }
      }


      if (!differentRoomModal && window.localStorage.getItem("patientCallId")) {
         if (isMobile) {
            return <MobileParentWaiting {...this.props} guestMobileNumber={newguestMobileNumber} guestName={guestName} />;
         } else {
            return <ParentWaiting {...this.props} guestMobileNumber={guestMobileNumber} guestName={guestName} />
         }
      }

      if (setting.currentUser && !differentRoomModal) {
         return <Loader />;
      }

      
		return (
         <ParentLoginWrapper>
           
           {this.state.warningVisible && <div className="WarningMessage">
               <h1>kure works best on the latest version of Chrome or Safari. Don’t have them installed? Download <a href="https://www.google.com/chrome/?brand=CHBD&gclid=EAIaIQobChMIuvq127ry6wIVR6aWCh3I1g1CEAAYASAAEgIxM_D_BwE&gclsrc=aw.ds" target="_blank">Chrome</a> or <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a>.</h1>
               <button onClick={this.closeWarning}  className="closewarningmsg">&times;</button>
            </div>}

            <div className="parentLogin">
               <div className="container">
                  <div className="row">
                     <div className="col-12 text-center">
                        <header className="header">
                           <div className="logo">
                              <img src={logoImage} width="95" />
                           </div>
                        </header>
                     </div>
                  </div>

                  <section className="content">
                     <div className="row">
                        <div className="col-lg-6 m-auto col-12">
                           <div className="login-block">
                              <h1>Enter the information below to join the call</h1>
                              <div className="room-detail">
                                 <h2>ROOM</h2>
                                 <h3>/{params.therapistRoom}</h3>
                              </div>

                              <div className="tabs-container">
                                 <Tabs onChange={this.handleTabClick} centered>
                                    <TabPane tab="kure User" key="kureUser">
                                       <div className="formRow">
                                          <div className="country-phone">
                                             <PhoneInput
                                                country={'us'}
                                                value={this.state.mobileNumber ? this.state.mobileNumber : ''}
                                                className="textbox" 
                                                onChange={phone => this.handleInputChange({ mobileNumber : phone})}  
                                                placeholder="Phone number"
                                             />
                                          </div>

                                          {/* <div className="patient__phonenumber">
                                             <div className="country__dropdown">
                                                   <div className="custom__countryselect">
                                                         <select onChange={(evt) => this.handleInputChange({ countryCode : evt.target.value})} >
                                                            {
                                                               countryCodeOptions.map((code, index) => <option key={index} value={code} selected={code === this.state.countryCode}>{"+" + code}</option>)
                                                            }
                                                         </select>
                                                   </div>
                                             </div>
                                             <div className="input-phone-box">
                                                <input type="text"
                                                      value={this.state.mobileNumber}
                                                      className="textbox" 
                                                      onChange={(evt) => this.handleInputChange({ mobileNumber : evt.target.value})}  
                                                      placeholder="Kure Phone Number" />
                                             </div>
                                          </div> */}
                                       </div>
                                    </TabPane>

                                    <TabPane tab="Patient/Caregiver" key="patientCaregiver">
                                       <div className="formRow">
                                          <input type="text" 
                                             value={patientLastName}
                                             className="textbox" 
                                             onChange={(evt) => this.handleInputChange({ patientLastName : evt.target.value})}  
                                             placeholder="Patient last name" />
                                       </div>
                                       
                                       <div className="formRow">
                                          <DatePicker className="textbox" 
                                             value={(patientDob && patientDob !== "") ? moment(patientDob) : ""}
                                             onChange={(date) => this.handleInputChange({ patientDob : date.format("YYYY-MM-DD")})} 
                                             format={dateFormat} 
                                             placeholder="Patient DOB" />
                                       </div>
                                    </TabPane>

                                    <TabPane tab="Guest" key="guest">
                                       <div className="formRow">
                                          <input type="text" 
                                             value={this.state.guestName}
                                             className="textbox" 
                                             onChange={(evt) => this.handleInputChange({ guestName : evt.target.value})}  
                                             placeholder="Your full name" />
                                       </div>

                                       <div className="formRow">
                                          <div className="country-phone">
                                             <PhoneInput
                                                country={'us'}
                                                value={this.state.guestMobileNumber}
                                                className="textbox" 
                                                onChange={phone => this.handleInputChange({ guestMobileNumber : phone})}  
                                                placeholder="Phone number (optional)"
                                             />
                                          </div>
                                       </div>
                                    </TabPane>
                                 </Tabs>
                              </div>
                              
                              <div className="button-action">
                                 <button disabled={disableButton} onClick={this.createActiveCall} className="joinbtn">Check In </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>
               </div>
            </div>

            {<JoinModal callDetails={patient.activeCall} currentRoom={params.therapistRoom} visible={this.state.differentRoomModal} />}
         </ParentLoginWrapper>
      ) 
	}
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(ParentLogin);